import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Zap, FileCheck, Infinity, ShieldCheck } from 'lucide-react';
import { trackAddToCart, trackInitiateCheckout } from '../utils/metaPixel';
function UrgencyCounter() {
  const [count, setCount] = useState(9);
  useEffect(() => {
    const decreaseCount = () => {
      setCount(prev => {
        if (prev <= 3) return prev;
        return prev - 1;
      });
      const nextInterval = Math.floor(Math.random() * (90000 - 45000 + 1)) + 45000;
      setTimeout(decreaseCount, nextInterval);
    };
    const timer = setTimeout(decreaseCount, Math.floor(Math.random() * 20000) + 10000);
    return () => clearTimeout(timer);
  }, []);
  return <div className="mt-4 flex flex-col items-center gap-1" data-id="element-223">
      <p className="text-red-500 font-bold text-lg animate-pulse" data-id="element-224">
        ⚠️ Últimos{' '}
        <motion.span key={count} initial={{
        scale: 1.4
      }} animate={{
        scale: 1
      }} className="inline-block text-2xl font-bebas" data-id="element-225">
          {count}
        </motion.span>{' '}
        mazos a este precio
      </p>
      <p className="text-white/50 text-sm" data-id="element-226">
        Después suben a{' '}
        <span className="text-white/70 font-semibold" data-id="element-227">$42.000 pesos</span>
      </p>
    </div>;
}
export function Pricing() {
  return <section className="py-10 px-4 bg-navy-800 relative" data-id="element-228">
      <div className="max-w-3xl mx-auto text-center" data-id="element-229">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="bg-navy-900 rounded-3xl p-8 md:p-12 border border-white/10 shadow-2xl relative overflow-hidden" data-id="element-230">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-gold to-transparent" data-id="element-231" />

          <p className="text-gold font-bebas text-2xl mb-2 tracking-widest" data-id="element-232">
            MAZO DE CARTAS ESPAÑOLAS +
          </p>
          <p className="text-gold font-bebas text-2xl mb-2 tracking-widest" data-id="element-233">
            MAZO DE "UNO" VERSIÓN SCALONETA
          </p>
          <p className="text-green-400 font-bebas text-xl mb-6 tracking-widest animate-pulse" data-id="element-234">
            + 2 BONOS GRATIS 🎁
          </p>

          <div className="mb-8 w-full max-w-md mx-auto" data-id="element-235">
            <img src="https://cdn.magicpatterns.com/uploads/owMBVXh4CqmVLkfH3FAS5w/37c67377-6743-4523-8444-a0a6cf017a62.png" alt="Pack completo Mazo de la Scaloneta con bonos" className="w-full h-auto rounded-xl shadow-[0_15px_40px_-10px_rgba(0,0,0,0.6),0_0_20px_rgba(212,175,55,0.1)]" data-id="element-236" />
          </div>

          <motion.div whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="inline-block mb-8" data-id="element-237">
            <a href="https://pay.hotmart.com/S105541783F?checkoutMode=10&_gl=1*1qohasg*_gcl_au*MzIzNDk2NTM5LjE3NzE4NTkzMjQ.*FPAU*MzIzNDk2NTM5LjE3NzE4NTkzMjQ.*_ga*MjA2NzE1OTc0MS4xNzYzODMxMDI4*_ga_GQH2V1F11Q*czE3NzcyODc2ODIkbzMwMiRnMSR0MTc3NzI4OTg1NiRqNTIkbDEkaDE2MTYyNjI0MDU.&bid=1777289868777" target="_blank" rel="noopener noreferrer" onClick={() => {
            trackAddToCart();
            trackInitiateCheckout();
          }} className="group relative inline-flex items-center justify-center gap-3 px-8 md:px-12 py-5 bg-gold text-navy-900 font-bold text-xl md:text-2xl rounded-xl overflow-hidden shadow-[0_0_40px_rgba(212,175,55,0.3)] hover:shadow-[0_0_60px_rgba(212,175,55,0.5)] transition-shadow animate-[pulse_2s_ease-in-out_infinite] no-underline" data-id="element-238">
              <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" data-id="element-239" />
              <span className="relative z-10" data-id="element-240">QUIERO MI EDICIÓN LIMITADA</span>
            </a>
          </motion.div>

          <div className="py-8 border-y border-white/5" data-id="element-241">
            <div className="flex items-center justify-center gap-3" data-id="element-242">
              <span className="text-7xl md:text-8xl font-bebas text-white drop-shadow-lg" data-id="element-243">
                $22.200
              </span>
              <span className="text-2xl font-bebas text-gold mt-4" data-id="element-244">pesos</span>
            </div>
            <UrgencyCounter data-id="element-245" />

            <div className="flex items-center justify-center gap-2 mt-4 text-green-400 text-sm" data-id="element-246">
              <span data-id="element-247">🛡️</span>
              <span className="font-medium" data-id="element-248">
                Garantía de 7 días — Devolución 100%
              </span>
            </div>
          </div>

          {/* Payment methods */}
          <div className="mt-6 flex flex-col items-center gap-3" data-id="element-249">
            <div className="text-white/60 text-sm" data-id="element-250">Pagá con:</div>
            <div className="flex items-center justify-center gap-5" data-id="element-251">
              {/* VISA */}
              <div className="px-5 py-2.5 bg-[#142787] rounded-lg flex items-center justify-center" data-id="element-252">
                <span className="text-white font-bold italic text-lg tracking-wider" data-id="element-253">
                  VISA
                </span>
              </div>
              {/* Mastercard */}
              <div className="px-5 py-2.5 bg-navy-800 border border-white/10 rounded-lg flex items-center justify-center" data-id="element-254">
                <div className="w-6 h-6 rounded-full bg-[#EB001B] opacity-90 z-10 translate-x-1.5" data-id="element-255"></div>
                <div className="w-6 h-6 rounded-full bg-[#F79E1B] opacity-90 -translate-x-1.5" data-id="element-256"></div>
              </div>
              {/* Mercado Pago */}
              <div className="px-4 py-2 bg-white rounded-lg flex items-center justify-center gap-2" data-id="element-257">
                <img src="https://cdn.magicpatterns.com/uploads/iWmpLkgUmC8xuDezegJkdt/images.jpg" alt="Mercado Pago" className="h-8 w-8 object-contain" data-id="element-258" />
                <span className="text-[#00214E] font-bold text-sm leading-tight" data-id="element-259">
                  mercado
                  <br data-id="element-260" />
                  pago
                </span>
              </div>
            </div>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-3 mt-8" data-id="element-261">
            <div className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-navy-800 border border-gold/30 text-sm text-white/80" data-id="element-262">
              <Zap className="w-4 h-4 text-gold" data-id="element-263" />
              <span data-id="element-264">Descarga inmediata</span>
            </div>
            <div className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-navy-800 border border-gold/30 text-sm text-white/80" data-id="element-265">
              <FileCheck className="w-4 h-4 text-gold" data-id="element-266" />
              <span data-id="element-267">Archivo digital de alta resolución</span>
            </div>
            <div className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-navy-800 border border-gold/30 text-sm text-white/80" data-id="element-268">
              <Infinity className="w-4 h-4 text-gold" data-id="element-269" />
              <span data-id="element-270">Acceso de por vida</span>
            </div>
            <div className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-navy-800 border border-gold/30 text-sm text-white/80" data-id="element-271">
              <ShieldCheck className="w-4 h-4 text-gold" data-id="element-272" />
              <span data-id="element-273">Único pago, sin mensualidades</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}